// extracted by mini-css-extract-plugin
export default {"options":"search-results-options_options__MLR81"};